import { render, staticRenderFns } from "./comfyuiTheme.vue?vue&type=template&id=996f1158&scoped=true&"
import script from "./comfyuiTheme.vue?vue&type=script&lang=js&"
export * from "./comfyuiTheme.vue?vue&type=script&lang=js&"
import style0 from "./comfyuiTheme.vue?vue&type=style&index=0&id=996f1158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996f1158",
  null
  
)

export default component.exports